<fieldset [class.disabled]="disabled">

  <input class="search-in-select"
         *ngIf="includeSearch && !disabled"
         placeholder="Search Dropdown"
         [(ngModel)]="searchTerm"
         (ngModelChange)="checkSearchLength()"
         (focus)="focusSelect(selectEl)"
         [ngModelOptions]="{standalone: true}" />

  <select #selectEl
          [disabled]="disabled"
          [(ngModel)]="value"
          (ngModelChange)="handleChange($event)"
          [required]="required"
          [name]="label"
          (mousedown)="openOnMouseDown($event, selectEl)"
          (keydown)="onSelectKeydown($event, selectEl)">

    <option *ngIf="!PDF"
            [ngValue]="null"
            disabled>
      Select {{ label }}
    </option>

    <option *ngFor="let option of filteredOptions"
            [ngValue]="option[valueKey]">
      {{ option[labelKey] }}
    </option>

  </select>

  <legend>{{ label }}</legend>

</fieldset>
